<template>
  <div
    class="wrap-modal"
    modal
  >
    <div class="scrim"></div>
    <div class="wrap_visible_block">
      <div class="wrap_background">
        <div
          class="wrap-criss-cross"
          @click="closePopup"
        >
          <svg
            class="criss-cross"
            viewBox="0 0 24 24"
          >
            <polygon points="8.5,7 7,8.5 10.5,12 7,15.5 8.5,17 12,13.5 15.5,17 17,15.5 13.5,12 17,8.5 15.5,7 12,10.5">
            </polygon>
          </svg>
        </div>
        <div class="wrap_content">
          <h2 class="title">{{ title }}</h2>
          <div class="text">{{ text }}</div>
        </div>
        <div>
          <div
            class="btn primary"
            @click="closePopup"
          >
            {{ getDeftextBtnPrimary }}
          </div>
          <a
            class="btn faq"
            href="https://multiplex.ua/ua/faq"
          >
            <span>{{ getDeftextBtnSecondary }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['eventCloseModal'],
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    textBtnPrimary: {
      type: String
    },
    textBtnSecondary: {
      type: String
    }
  },
  methods: {
    closePopup () {
      this.$emit('eventCloseModal')
    }
  },
  computed: {
    getDeftextBtnPrimary: function () {
      return (
        this.textBtnPrimary ||
        this.$t('pop_ups.login_page.open_id_exception.btns.primary')
      )
    },
    getDeftextBtnSecondary: function () {
      return (
        this.textBtnSecondary ||
        this.$t('pop_ups.login_page.open_id_exception.btns.secondary')
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// modal-popup.vue?621f9e66